/**
 * External dependencies.
 */
import { useState } from "react";
import { Trans } from "@lingui/macro";

/**
 * Internal dependencies.
 */
import Link from "components/link/link";
import { fetchAPI } from "utils";

interface UsefulProp {
  path: string;
  global: any;
}

const Useful: React.FC<UsefulProp> = ({ path, global }) => {
  const [active, setActive] = useState(true);
  const handleClick = (type: any) => {
    fetchAPI(path, "", {
      method: "put",
      body: JSON.stringify({
        data: type,
      }),
    });
    setActive(!active);
  };

  if (!active) {
    return (
      <div className="useful">
        <h6>
          <Trans>Thank you for your feedback!</Trans>
        </h6>
      </div>
    );
  }

  return (
    <div className="useful">
      <h6>
        <Trans>Was this article helpful?</Trans>
      </h6>
      <div className="useful__cta">
        <button
          className="btn btn--white"
          onClick={() => handleClick({ Useful: true })}
        >
          Yes
        </button>
        <button
          className="btn btn--white"
          onClick={() => handleClick({ NotUseful: true })}
        >
          No
        </button>
      </div>
      <p>
        <Trans>Have more questions?</Trans>{" "}
        <Link
          href={
            global.attributes.RequestEmail?.match(/\w@\w/)
              ? `mailto:${global.attributes.RequestEmail}`
              : global.attributes.RequestEmail
          }
        >
          <Trans>Submit a request</Trans>
        </Link>
      </p>
    </div>
  );
};

export default Useful;
